const isCreator = (id) => {
  const currentSession = JSON.parse(localStorage.getItem("session"));
  const councilRole = localStorage.getItem("council_role");
  const council = JSON.parse(localStorage.getItem("council"));

  return id === currentSession.id
    || councilRole === "council_administrator"
    || councilRole === "ttp_administrator"
    || council.name === "Kyndryl";
};

export { isCreator };
